import builder from '../builder';
import RealEstateDimensionsBlock from '../../streamline-icons/light/real-estate-dimensions-block.svg';

export default builder(
  'IconRealEstateDimensionsBlockLight',
  RealEstateDimensionsBlock,
);
